module.exports = __webpack_public_path__ + "static/media/imgAppNotfaund.7648106c.svg";